document.addEventListener("DOMContentLoaded", () => {
  // Handle color & size filters
  const filterButtons = document.querySelectorAll(".color-swatch, .size-btn");

  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const filterUrl = btn.dataset.filterUrl;
      if (!filterUrl) return;
  
      const currentUrl = new URL(window.location.href);
      const newFilterUrl = new URL(filterUrl, window.location.origin);
      const newParams = newFilterUrl.searchParams;
  
      const isColor = btn.classList.contains("color-swatch");
      const isSize = btn.classList.contains("size-btn");
  
      // If button is already active, it means we should REMOVE its filter only (no re-add)
      if (btn.classList.contains("active")) {
        window.location.href = filterUrl; // url_to_remove
        return;
      }
  
      // Otherwise, remove existing filters of same type before adding the new one
      for (const [key] of currentUrl.searchParams.entries()) {
        if (isColor && key.includes("filter.v.option.color")) {
          currentUrl.searchParams.delete(key);
        }
        if (isSize && key.includes("filter.v.option.größe")) {
          currentUrl.searchParams.delete(key);
        }
      }
  
      // Add new filter parameters
      newParams.forEach((value, key) => {
        currentUrl.searchParams.set(key, value);
      });
  
      // Redirect to the clean new URL
      window.location.href = currentUrl.toString();
    });
  });
  

  // In-stock toggle
  /*const stockToggle = document.getElementById("in-stock-toggle");
  if (stockToggle) {
    stockToggle.addEventListener("change", () => {
      const currentUrl = new URL(window.location.href);
      if (stockToggle.checked) {
        currentUrl.searchParams.set("filter.v.availability", "1");
      } else {
        currentUrl.searchParams.delete("filter.v.availability");
      }
      window.location.href = currentUrl.toString();
    });
  }*/
    const inStockToggle = document.querySelector(".in-stock-toggle");

    if (inStockToggle) {
      inStockToggle.addEventListener("change", () => {
        const filterUrl = inStockToggle.dataset.filterUrl;
        if (!filterUrl) return;
    
        const currentUrl = new URL(window.location.href);
        const newFilterUrl = new URL(filterUrl, window.location.origin);
        const newParams = newFilterUrl.searchParams;
    
        // Remove any existing availability filters
        for (const [key] of currentUrl.searchParams.entries()) {
          if (key.includes("filter.v.availability")) {
            currentUrl.searchParams.delete(key);
          }
        }
    
        // Add the new availability filter when toggled ON
        if (inStockToggle.checked) {
          newParams.forEach((value, key) => {
            currentUrl.searchParams.set(key, value);
          });
        }
    
        //  Preserve pathname (handles dynamic collections)
        window.location.href = `${window.location.origin}${currentUrl.pathname}?${currentUrl.searchParams.toString()}`;
      });
    }
    

  // View switcher
  const productGrid = document.querySelector('[id^="product-grid"]');
  document.querySelectorAll(".view-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".view-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      const view = btn.dataset.view;
      if (productGrid) {
        productGrid.classList.toggle("list-view", view === "list");
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", () => {
  const productGridContainer = document.querySelector("#product-grid");

  // Handle grid layout buttons
  document.querySelectorAll(".grid-toggle-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const columns = btn.dataset.columns;

      // Remove active state from all buttons
      document.querySelectorAll(".grid-toggle-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      // Update the grid class
      productGridContainer.classList.remove("grid-3", "grid-4", "grid-6");
      productGridContainer.classList.add(`grid-${columns}`);

      // Save user preference in localStorage
      localStorage.setItem("shopify-grid-columns", columns);
    });
  });

  // Restore saved layout preference
  const savedColumns = localStorage.getItem("shopify-grid-columns");
  if (savedColumns && productGridContainer) {
    productGridContainer.classList.remove("grid-3", "grid-4", "grid-6");
    productGridContainer.classList.add(`grid-${savedColumns}`);

    // Set button active state
    document.querySelectorAll(".grid-toggle-btn").forEach(btn => {
      btn.classList.toggle("active", btn.dataset.columns === savedColumns);
    });
  }
});
